import { PROPERTY_COMPANY_UPLOAD_RENT_ROLL_OR_PROVIDE_TENANT_INFO } from '../../../../../../../constants';
import { ApplicationFormValues } from '../../../../LoanDetailTypes';
import loanFormModel from '../../form_models/loanFormModel';
import { Rule } from '../../interfaces/Rule';

const { propertyCompanyUploadRentRollOrProvideTenantInfo } =
  loanFormModel.formField;

class RentRollOrTenantInfoAnswerIs implements Rule {
  private answer: PROPERTY_COMPANY_UPLOAD_RENT_ROLL_OR_PROVIDE_TENANT_INFO;

  public setAnswer(
    answer: PROPERTY_COMPANY_UPLOAD_RENT_ROLL_OR_PROVIDE_TENANT_INFO
  ) {
    this.answer = answer;
    return this;
  }

  public evaluate(data: Partial<ApplicationFormValues>): boolean {
    return (
      data[propertyCompanyUploadRentRollOrProvideTenantInfo.name] ===
      this.answer
    );
  }
}

export default new RentRollOrTenantInfoAnswerIs();
